import "./index.css";
import Dashboard from "./Dashboard";
import * as serviceWorker from "./serviceWorker";
import { TestProject } from "./Constants";
import { closeSnackbar, SnackbarProvider } from "notistack";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ProjectStore, { ProjectStoreProvider } from "./model/ProjectStore";
import ViewState, { ViewStateProvider } from "./model/ViewState";
import { LicenseInfo } from "@mui/x-license";
import { createRoot } from "react-dom/client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

LicenseInfo.setLicenseKey(
  "ab3d1a04ad93731606b1efa25a34f1f0T1JERVI6MjI3NDMsRVhQSVJZPTE2NDc4MDA0OTkwMDAsS0VZVkVSU0lPTj0x"
);

let projState = JSON.parse(localStorage.getItem("sma_eva_state_mobx"));
if (projState == null) {
  projState = TestProject();
}
let projectStore = ProjectStore.fromJS(TestProject());
let viewState = new ViewState();

const theme = createTheme({
  palette: {
    primary: {
      main: '#3F51B5',
    },
  },
});

const root = createRoot(document.getElementById("root"));
root.render(
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    action={(snackbarId) => (
      <IconButton onClick={() => closeSnackbar(snackbarId)} color="inherit">
        <CloseIcon />
      </IconButton>
    )}
  >
    <ThemeProvider theme={theme}>
      <DndProvider backend={HTML5Backend}>
        <ProjectStoreProvider store={projectStore}>
          <ViewStateProvider state={viewState}>
            <Dashboard />
          </ViewStateProvider>
        </ProjectStoreProvider>
      </DndProvider>
    </ThemeProvider>
  </SnackbarProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
